<template>
    <LFilters
        :filters="filters"
        :loading="isLoading"
        @clear="SET_EMPTY('filters')"
        @confirm="confirmFilters">
        <template #filters>
            <div class="columns is-multiline">
                <FilterWrapper>
                    <CustomDatepicker v-model="datepicker"></CustomDatepicker>
                </FilterWrapper>

                <div class="column is-narrow">
                    <CurrencyCheckbox v-model="currency"></CurrencyCheckbox>
                </div>

                <div class="column is-narrow">
                    <b-field>
                        <CustomCheckbox
                            v-model="withBlockedManager"
                            switchable
                            :label="$t('admin.statistics.statistics.filters.labels.withBlockedWebmaster')"></CustomCheckbox>
                    </b-field>
                </div>

                <!--      TODO:Добавить когда будет график      -->
                <!--            <div class="column is-narrow">-->
                <!--                <LTooltip-->
                <!--                    :label="chartTooltipLabel"-->
                <!--                    position="is-left"-->
                <!--                    type="is-info">-->
                <!--                    <b-field class="chart-open-toggle-button">-->
                <!--                        <b-checkbox-button-->
                <!--                            :value="isEfficiencyChartOpen"-->
                <!--                            type="is-info is-light"-->
                <!--                            @input="$emit('update:isEfficiencyChartOpen', $event)">-->
                <!--                            <b-icon-->
                <!--                                icon="chart-pie"-->
                <!--                                size="is-small">-->
                <!--                            </b-icon>-->
                <!--                        </b-checkbox-button>-->
                <!--                    </b-field>-->
                <!--                </LTooltip>-->
                <!--            </div>-->
            </div>
        </template>
    </LFilters>
</template>

<script>
  import CurrencyCheckbox from "@/components/Common/Controls/CurrencyCheckbox.vue";
  import CustomDatepicker from "@/components/Common/Date/CustomDatepicker.vue";
  import LFilters from "@/components/Common/LFilters";
  import {
    UPDATE_EFFICIENCY_FILTERS,
    UPDATE_FILTERS,
    SET_EMPTY
  } from "@core/store/mutation-constants";
  import { GET_EFFICIENCY } from "@core/store/action-constants";
  import { mapFields } from "@vasiliyrusin/vue-mapfields";
  import { mapActions, mapState } from "vuex";
  import CustomCheckbox from "@/components/Common/Controls/CustomCheckbox.vue";

  export default {
    name: "EfficiencyFilters",
    components: {
      CustomDatepicker,
      CurrencyCheckbox,
      CustomCheckbox,
      LFilters
    },

    props: {
      isEfficiencyChartOpen: {
        type: Boolean,
        required: true
      }
    },

    computed: {
      ...mapFields("filtersConfirm", {
        fields: ["datepicker", "currency", "withBlockedManager"],
        base: "filters",
        action: UPDATE_FILTERS
      }),

      ...mapState("admin/efficiency", {
        filters: ({ filters }) => filters
      }),

      chartTooltipLabel () {
        return this.isEfficiencyChartOpen
          ? this.$t("admin.efficiency.filters.labels.closeChart")
          : this.$t("admin.efficiency.filters.labels.openChart");
      },

      isLoading () {
        return this.$wait(`admin/efficiency/${ GET_EFFICIENCY }`);
      }
    },

    methods: {
      ...mapActions("admin/efficiency", [
        UPDATE_EFFICIENCY_FILTERS,
        GET_EFFICIENCY,
        SET_EMPTY
      ]),

      confirmFilters ({ filters }) {
        this.UPDATE_EFFICIENCY_FILTERS(filters);
        this.GET_EFFICIENCY();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .columns {
    align-items: flex-end;
  }

  ::v-deep {
    .chart-open-toggle-button {
      .icon {
        //noinspection SassScssUnresolvedVariable
        margin-left: -14.5px !important;
        //noinspection SassScssUnresolvedVariable
        margin-right: -14.5px !important;
      }
    }
  }

  .checkbox {
    .tag {
      margin-left: 0.8em;
    }
  }
</style>
